module.exports = __webpack_public_path__ + "img/zjga.d0289dc0.png";